import {reformatOpenAiResponseToHtml} from '@/utils/string';

/** Paragraph extend output must stay inline — no headings or tables inside a block. */
export function sanitizeExtendedParagraphHtml(raw: unknown): string {
    let html = reformatOpenAiResponseToHtml(String(raw || '')) || '';
    if (!html.trim()) {
        return '';
    }
    html = html
        .replace(/<h[1-6][^>]*>[\s\S]*?<\/h[1-6]>/gi, ' ')
        .replace(/<table[\s\S]*?<\/table>/gi, ' ')
        .replace(/^\s*#+\s+/gm, '');
    if (!/<p\b/i.test(html)) {
        html = `<p>${html.trim()}</p>`;
    }
    return html.replace(/\s+/g, ' ').trim();
}
